import { render, staticRenderFns } from "./TimeWidgetPanel.vue?vue&type=template&id=31e09224&scoped=true"
import script from "./TimeWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TimeWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TimeWidgetPanel.vue?vue&type=style&index=0&id=31e09224&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e09224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e09224')) {
      api.createRecord('31e09224', component.options)
    } else {
      api.reload('31e09224', component.options)
    }
    module.hot.accept("./TimeWidgetPanel.vue?vue&type=template&id=31e09224&scoped=true", function () {
      api.rerender('31e09224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TimeWidgetPanel.vue"
export default component.exports